import React, { useState } from 'react';
import CustomModal from 'components/CustomModal';
import KSButton from 'presentation/components/KSButton';
import './DismissAuditModal.scss';

export interface DismissAuditModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (comment: string) => void;
  isLoading?: boolean;
}

const DismissAuditModal: React.FC<DismissAuditModalProps> = ({ isOpen, onClose, onConfirm, isLoading = false }) => {
  const [comment, setComment] = useState('');

  const handleConfirm = () => {
    onConfirm(comment);
  };

  const handleClose = () => {
    setComment('');
    onClose();
  };

  return (
    <CustomModal
      isOpen={isOpen}
      onRequestClose={handleClose}
      className="dismiss-audit-modal"
      shouldCloseOnEsc={!isLoading}
      shouldCloseOnOverlayClick={!isLoading}
    >
      <div className="dismiss-audit-modal-header">
        <h2>Dismiss Audit Alert</h2>
      </div>

      <div className="dismiss-audit-modal-body">
        <p className="dismiss-audit-modal-description">Please include reason for dismissal </p>

        <textarea
          className="dismiss-audit-modal-textarea"
          placeholder="Enter your comment here..."
          value={comment}
          onChange={e => setComment(e.target.value)}
          rows={5}
          disabled={isLoading}
        />
      </div>

      <div className="dismiss-audit-modal-footer">
        <KSButton variant="outlined" size="medium" onClick={handleClose} label="Cancel" disabled={isLoading} />
        <KSButton
          variant="contained"
          size="medium"
          onClick={handleConfirm}
          label={isLoading ? 'Dismissing...' : 'Dismiss'}
          disabled={!comment.trim() || isLoading}
        />
      </div>
    </CustomModal>
  );
};

export default DismissAuditModal;
